import { setRoutes } from 'modules/routes';
import FindStoreSearch from './findStore';
import FindStoreList from './components/findStoreList';

export const FindStore = setRoutes(
    (props): JSX.Element => (
        <FindStoreSearch {...props}>
            <FindStoreList />
        </FindStoreSearch>
    )
);

export { FindStore as default, FindStoreSearch, FindStoreList };
